<template>
    <tr class="action_field in_memor">
        <td class="field_insert small center-align">
            {{field.number}}
        </td>
        
        <td class="field_insert small tdtp">
            <span class="cursor-pointer" v-on:click="show_info(field)">
                   {{field.org_name}}
            </span>
        </td>
        
        <td class="field_insert  small kp" v-html="field.price"></td>
        <td class="field_insert main_big" v-html="field.terms"></td>
        <td class="field_insert  big" v-html="field.payment"></td>
    </tr>

</template>

<script>
export default {
    name: "tender_field",
    props: {
        field : {
            type : Object,
            
        }
    },
    methods : {
        show_info(field) {
            this.$emit('click_item',field);
        }
    }
}
</script>

<style scoped>

</style>